import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Card, Alert, CardBody, Button, Modal, ModalBody, Label } from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

// import Utils from '../../Utility';
import Utils from '../Utility';

// actions
import { post, upload, put, get } from '../../helpers/api_helper';
import { toast } from 'react-toastify';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";
import Multiselect from 'multiselect-react-dropdown';



const AddProperty = props => {
    const { user, data, setLoading, loading, role, getData, setIsAdd, currentData, setCurrentData, thumb, setThumb, type, file, setFile, setBanners, banners, setTag, tag } = props;
    // const [file, setFile] = useState(null);
    const [files, setFiles] = useState([]);
    const imageInput = useRef();
    const cropper = useRef();
    const [descContent, setDescContent] = useState(null);
    // const [banners, setBanners] = useState([]);
    const [desc, setDesc] = useState("");
    const [cropperModal, setCropperModal] = useState(false);
    const [checkbox, setCheckbox] = useState(false);
    const [currentFile, setCurrentFile] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [fileType, setFileType] = useState('thumb');
    const cropperRef = useRef();
    const imagePickerRef = useRef();
    const [catSet, setCatSet] = useState(undefined);
    const [tech, setTech] = useState([]);
    const [selectedTech, setSelectedTech] = useState([]);
    // const [select, setSelect] = useState([]);

    const handleValidSubmit = async (e, v) => {
        if (!loading) {
            // if (banners?.length < 1) {
            //     toast.error(`Please select atleast one banner Image!`);
            //     return;
            // }
            if (selectedTech.length < 1) {
                toast.error('Select at least one Technology');
                return;
            }
            let arr = [];
            selectedTech?.map((item) => {
                arr.push(item?._id);
            })
            setLoading(true);
            let body = {
                ...v,
                tech: arr,
                token: user?.token
            }
            if (currentData?._id) {
                body = {
                    ...body,
                    jobId: currentData?._id
                }
                put("/jobs", body)
                    .then(res => {
                        setLoading(false);
                        if (res?.statusCode == 200) {
                            toast.success(res?.message);
                            closeTab()
                        } else
                            toast.error("" + res?.error);
                    })
                    .catch(err => {
                        setLoading(false);
                        console.error("error while updating data", err);
                        toast.error("Something Went Wrong!");
                    })
            } else {

                post("/jobs", body)
                    .then(res => {
                        console.log("check blog data submit res=====>", res);
                        setLoading(false);
                        if (res?.statusCode == 200) {
                            toast.success(res?.message);
                            closeTab()
                        } else {
                            toast.error(res?.error);
                        }
                    })
                    .catch(err => {
                        setLoading(false);
                        console.error("Error while adding blog", err);
                        toast.error("Something Went Wrong!");
                    })
            }
        }
    }

    const getTypes = () => {
        get("/project/tech", { token: user?.token })
            .then(res => {
                if (res?.statusCode == 200) {
                    setTech(res?.data);
                }
            })
            .catch(err => {
                toast.error("Something Went Wrong!");
            });
    }

    const closeTab = () => {
        props.setCurrentData(null);
        changeImage();
        setBanners([]);
        setThumb(null);
        props?.close(false)
    }

    useEffect(() => {
        // console.log("checkbox data =====>", currentData);
        if (currentData) {
            setSelectedTech(currentData?.tech);
        }
    }, [currentData]);

    useEffect(() => {
        getTypes();
    }, [user])

    const onChangeFile = async (e, type) => {
        console.log('on change file', e.target);
        setCurrentFile(URL.createObjectURL(e.target.files[0]));
        setCropperModal(true);
    }

    const removeImage = (i) => {
        let data = Object.assign([], files);
        data.splice(i, 1);
        setFiles(data);
    }

    const onEditorStateChange = (editorState) => {
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        setDesc(html);
        setDescContent(editorState);
    }

    const cropImage = () => {
        setLoading(true);
        const fileData = cropperRef?.current?.cropper?.getCroppedCanvas().toDataURL();
        if (fileType == "banner") {
            let temp = Object.assign([], banners);
            temp.push(fileData);
            setBanners(temp);
        } else {
            setThumb(fileData);
        }
        setCropperModal(false);
        setLoading(false);
    }

    const urltoFile = (url, filename, mimeType) => {
        return (fetch(url)
            .then(function (res) { return res.arrayBuffer(); })
            .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
        );
    }

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                1800,
                600,
                "webp",
                60,
                0,
                (uri) => {
                    resolve(uri);
                },
                "file"
            );
        });

    const handleImgChange = (file) => {
        setFile(URL.createObjectURL(file));
        setCropperModal(true);
    }

    const handleRemoveBanner = (i) => {
        let temp = Object.assign([], banners);
        temp.splice(i, 1);
        setBanners(temp);
    }

    const handleChangeInput = (list) => {
        let temp = []
        list?.map((item) => (
            temp.push({ id: item?.id, name: item?.name })
        ))
        setCatSet(temp)
        console.log("ddad tags", list);
        setSelectedTags(temp);
    }

    function changeImage() {
        setThumb(null);
        if (currentData) {
            props.setCurrentData({ ...currentData, thumb: undefined })
        }
    }

    console.log("selectedlist", selectedTech);

    return (
        <React.Fragment>
            <div>
                <Modal isOpen={cropperModal} centered={true}>
                    <ModalBody>
                        <h5 className="text-black font-size-20">Crop Image</h5>
                        <div className="p-2">
                            <AvForm
                                className="form-horizontal"
                                onValidSubmit={(e, v) => {
                                    cropImage()
                                }}
                            >
                                <div className="mb-3 mt-2">
                                    <Cropper
                                        style={{ height: 200, width: 400 }}
                                        // aspectRatio={fileType == 'banner' ? 2 / 1 : '' / 'auto'}
                                        preview=".img-preview"
                                        guides={true}
                                        src={file}
                                        ref={cropperRef}
                                    />
                                </div>
                                <div className="mt-4">
                                    <Row>
                                        <Col md={6}>
                                            <button
                                                style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor }}
                                                className="btn w-100 waves-effect waves-light"
                                                onClick={() => { setCropperModal(false); setFile(null) }}
                                                type="reset"
                                            >
                                                Cancel
                                            </button>
                                        </Col>
                                        <Col md={6}>
                                            <button
                                                className="btn w-100 waves-effect waves-light"
                                                type="submit"
                                                style={{
                                                    border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor
                                                }}
                                            >
                                                Submit
                                            </button>
                                        </Col>
                                    </Row>
                                </div>
                            </AvForm>
                        </div>
                    </ModalBody>
                </Modal>
                <input
                    name="images"
                    label="image"
                    className="d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImgChange(e.target.files[0])}
                    ref={imagePickerRef}
                />
                <h4 className="card-title mb-4">{currentData ? 'Update ' + role : 'Add a ' + role}</h4>
                <Card>
                    <CardBody>
                        <Row>
                            <Col lg={12} md={12}>
                                <div className="text-center close_button" style={{ marginLeft: 'auto' }}>
                                    <button color="primary" className='btn btn' onClick={() => { closeTab() }} style={{ backgroundColor: Utils.themeColor, color: Utils.textColor, border: 'none' }}>
                                        Close
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <AvForm
                            className="form-horizontal"
                            onValidSubmit={(e, v) => { handleValidSubmit(e, v) }}>
                            <Row>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="title"
                                            label="Title*"
                                            value={currentData?.title}
                                            className="form-control"
                                            placeholder="Enter project title."
                                            type="text"
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={8}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="desc"
                                            label="Description *"
                                            value={currentData?.desc}
                                            className="form-control"
                                            placeholder="Enter short description"
                                            type="text"
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="quali"
                                            label="Qualification *"
                                            value={currentData?.quali}
                                            className="form-control"
                                            placeholder="Enter qualification."
                                            type="select"
                                            required
                                        >
                                            <option value="">Select Qualification</option>
                                            <option value="10th">10th</option>
                                            <option value="12th">12th</option>
                                            <option value="Diploma">Diploma</option>
                                            <option value="Graduate">Graduate</option>
                                            <option value="Post Graduate">Post Graduate</option>
                                            <option value="PHD">PHD</option>
                                        </AvField>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="jobType"
                                            label="Job Type *"
                                            value={currentData?.jobType}
                                            className="form-control"
                                            type="select"
                                            required
                                        >
                                            <option value="">Select Job Type</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Full Time">Full Time</option>
                                            <option value="Part Time">Part Time</option>
                                            <option value="Freelance">Freelance</option>
                                            <option value="Consultant">Consultant</option>
                                        </AvField>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="position"
                                            label="Position *"
                                            value={currentData?.position}
                                            className="form-control"
                                            placeholder="Enter position."
                                            type="select"
                                            required
                                        >
                                            <option value="">Select Position</option>
                                            {Utils.jobPositions?.map((item) => (
                                                <option value={item?.value}>{item?.title}</option>
                                            ))}
                                        </AvField>
                                    </div>
                                </Col>
                                <Col md={8}>
                                    <div className="form-group mb-4">
                                        <Label>Technologies *</Label>
                                        <Multiselect
                                            options={tech}
                                            selectedValues={selectedTech}
                                            onSelect={(selectedList, selectedItem) => setSelectedTech(selectedList)}
                                            onRemove={(selectedList, removedItem) => setSelectedTech(selectedList)}
                                            displayValue="title"
                                            placeholder={"Select Technologies"}
                                            showCheckbox
                                            name="Technologies"
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="vacancies"
                                            label="Vacancies *"
                                            value={currentData?.vacancies}
                                            className="form-control"
                                            placeholder="Enter number of positions"
                                            type="number"
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="priority"
                                            label="Priority *"
                                            value={currentData?.priority}
                                            className="form-control"
                                            placeholder="Enter priority."
                                            type="select"
                                            required
                                        >
                                            <option value="">Select Priority</option>
                                            <option value="Instant Join">Instant Join</option>
                                            <option value="10 Days">10 Days</option>
                                            <option value="15 Days">15 Days</option>
                                            <option value="30 Days">30 Days</option>
                                        </AvField>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="exper"
                                            label="Experience *"
                                            value={currentData?.exper}
                                            className="form-control"
                                            placeholder="Enter experience"
                                            type="select"
                                            required
                                        >
                                            <option value="">Select Experience</option>
                                            <option value="Fresher">Fresher</option>
                                            <option value="1-2 Years">1-2 Years</option>
                                            <option value="2-3 Years">2-3 Years</option>
                                            <option value="3-5 Years">3-5 Years</option>
                                            <option value="5-7 Years">5-7 Years</option>
                                            <option value="7-10 Years">7-10 Years</option>
                                            <option value="10+ Years">10+ Years</option>
                                        </AvField>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="location"
                                            label="Location *"
                                            value={currentData?.location}
                                            className="form-control"
                                            placeholder="Enter location"
                                            type="text"
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="response"
                                            label="Responsibilities *"
                                            value={currentData?.response}
                                            className="form-control"
                                            placeholder="Enter responsibilities."
                                            type="textarea"
                                            rows={8}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <div className="text-center mt-4">
                                {currentData ?
                                    <button type="submit" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor }}>
                                        Update {role}
                                    </button>
                                    :
                                    <button type="submit" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor }}>
                                        Add {role}
                                    </button>
                                }
                            </div>
                        </AvForm>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment >
    )
}

AddProperty.propTypes = {
    error: PropTypes.any,
    success: PropTypes.any,
    companyError: PropTypes.func,
    companySuccess: PropTypes.func,
    createCompany: PropTypes.func,
    updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
    const { user } = state.Profile;
    return { user }
}

export default withRouter(
    connect(mapStatetoProps, {})(AddProperty)
)
